import { createActionsHook } from 'src/lib/sweetState';

import { PageStore } from './PageStore';

export const usePageActions = createActionsHook(PageStore);
